import { ReactNode, createContext, useContext } from 'react';
import { TitanKybDataResponse } from 'services/merchants/types';

export interface AutoKybFlowContextValue {
  run: () => Promise<void>;
  isProcessing: boolean;
  titanData: TitanKybDataResponse | undefined;
  isLoadingTitanData: boolean;
}

const AutoKybFlowContext = createContext<AutoKybFlowContextValue | null>(null);

interface AutoKybFlowProviderProps {
  children: ReactNode;
  value: AutoKybFlowContextValue;
}

export const AutoKybFlowProvider = ({ children, value }: AutoKybFlowProviderProps) => {
  return <AutoKybFlowContext.Provider value={value}>{children}</AutoKybFlowContext.Provider>;
};

export const useAutoKybFlowContext = (): AutoKybFlowContextValue => {
  const context = useContext(AutoKybFlowContext);
  if (!context) {
    throw new Error('useAutoKybFlowContext must be used within an AutoKybFlowProvider');
  }
  return context;
};
